import React, { useEffect, useState } from "react";
import { GetQueueEventlogs } from "../../api/api";
import { useParams } from "react-router-dom";
import { io } from "socket.io-client";
import { SkeletonCard } from "../../context/Customfunction";

function CrowdEventDetail() {
  const id = useParams();
  const [loading, setLoading] = useState(false);
  const cameraUrl = localStorage.getItem("rtspurl");
  const [cameraData, setCameraData] = useState([]);
  console.log("cameraData", cameraData);
  const [queuelogs, setQueueLogs] = useState([]);
  const [visibleCount, setVisibleCount] = useState(10);
  const [crowdNotification, setCrowdeNotifications] = useState([]);

  useEffect(() => {
    let socket;

    const connectSocket = () => {
      if (socket) {
        socket.disconnect();
      }

      socket = io("http://192.168.20.24:5000", {
        reconnectionAttempts: 2,
        reconnectionDelay: 3000,
      });

      socket.on("connect", () => {
        console.log("Crowd socket connected");
      });

      const handleViolence = (data) => {
        console.log("people_data", data);
        setCrowdeNotifications((prev) => [data, ...prev]);
      };

      socket.on("people_data", handleViolence);

      // Store for cleanup
      socket.cleanup = () => {
        socket.off("people_data", handleViolence);
        socket.disconnect();
      };
    };

    // Connect immediately
    connectSocket();

    // Reconnect every 5 minutes (300000 ms)
    const intervalId = setInterval(() => {
      console.log("Reconnecting socket...");
      connectSocket();
    }, 300000);

    return () => {
      clearInterval(intervalId);
      if (socket) socket.cleanup?.();
    };
  }, []);

  return (
    <div className="d-flex fullHeightCst">
      {/* LEFT SECTION */}
      <div className="leftSection">
        <div className="titleFiltrer d-flex align-items-center p-4 border-bottom bg-white">
          <div className="col-xl-7">
            <h2 className="mb-0">Camera Logs</h2>
          </div>
          <div className="col-xl-5">
            {/* <div className="d-flex gap-2">
                    <div className="d-flex flex-column mt-0" style={{ minWidth: "140px" }}>
                      <input
                        id="dateFilter"
                        type="date"
                        className="form-control"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        max={new Date().toISOString().split("T")[0]}
                      />
                    </div>
                  </div> */}
          </div>
        </div>

        <div className="p-4">
          <h5 className="mb-3">Entrance Camera Group</h5>
          <div className="cameraGrid">
            <div className="image-box bg-white">
              <img
                src={`https://visionemptrack.greymatterz.com/crowd_detection/video_feed/${id?.id}`}
                alt="queue"
                className="img-fluid"
                // style={{ height: "200px", objectFit: "cover", width: "100%" }}
              />
              <div className="text-center py-2"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="rightSection bg-white border-start">
        {/* <div className="titleFiltrer d-flex align-items-center justify-content-between p-4 border-bottom bg-white">
          <h2>Details</h2>
        </div>
        <div className="px-3 my-3 cstHeighRight">
          {loading ? (
            Array.from({ length: 5 }).map((_, i) => <SkeletonCard key={i} />)
          ) : (
            <>
              <table className="table cstTable table-sm mb-0">
                <thead className="sticky-top" style={{ top: 0, zIndex: 1 }}>
                  <tr>
                    <td>S.No.</td>
                    <td>No of Preset</td>
                    <td>Limit</td>
                    <td>Status</td>
                  </tr>
                </thead>
                <tbody>
                  {crowdNotification &&
                    crowdNotification?.map((ele, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{ele?.present_people}</td>

                          <td>{ele?.limit}</td>
                          <td>{ele?.overcrowded ? "overcrowded" : "idel"}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              {visibleCount < queuelogs.length && (
                <div className="text-center mt-3">
                  <button
                    className="btn btn-primary"
                    onClick={() => setVisibleCount((prev) => prev + 10)}
                  >
                    Load More
                  </button>
                </div>
              )}
            </>
          )}
        </div> */}
      </div>
    </div>
  );
}

export default CrowdEventDetail;
